function createPayload(dataForm, dataActiveContract) {
    const [dddCellphone, cellphone] = dataForm.cellphone.value
        ? dataForm.cellphone.unmaskedValue.replace(/\(|\)/g, '').split(' ')
        : ['', ''];
    const [dddComercialPhone, comercialPhone] = dataForm.comercialPhone.value
        ? dataForm.comercialPhone.unmaskedValue.replace(/\(|\)/g, '').split(' ')
        : ['', ''];

    const payload = {
        CodigoLocalTrabalho: dataForm.costCenterCode.value,
        NomeLocalTrabalho: dataForm.costCenterName.value,
        SiglaLocal: dataForm.costCenterInitials.value,
        NumeroContrato: dataActiveContract.numero,
        NomeContatoAC: dataForm.costCenterResponsible.value,
        Endereco: {
            CEP: dataForm.cep.unmaskedValue,
            CodigoMunicipio: dataForm.city.value,
            NomeCidade: dataForm.city.lookup,
            SiglaUF: dataForm.uf.value,
            // CodigoBairro: dataForm.campo.value,
            NomeBairro: dataForm.hood.value,
            NomeLogradouro: dataForm.address.value,
            NumeroEndereco: dataForm.addressNumber.value,
            TextoComplemento: dataForm.complement.value,
            NumeroDDDCelular: dddCellphone,
            NumeroCelular: cellphone,
            NumeroDDDTelefone1: dddComercialPhone,
            NumeroTelefone1: comercialPhone,
            NumeroRamal1: dataForm.ramal.value,
            EnderecoEmail: dataForm.email.value,
        },
    };

    return payload;
}

export default createPayload;
